import { render, staticRenderFns } from "./ContractProfileTemplate.vue?vue&type=template&id=5253f5ac&scoped=true&"
import script from "./ContractProfileTemplate.vue?vue&type=script&lang=ts&"
export * from "./ContractProfileTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5253f5ac",
  null
  
)

export default component.exports